import React from 'react'
import { shallow } from 'enzyme'
import GenieRow from '../features/dashboard/GenieRow'

describe('<GenieRow />', () => {
  let wrapper, props
  it('should render a <Cell /> for each element of its provided data array', () => {
    props = {
      data: [1, 2, 3, 4, 5]
    }
    wrapper = shallow(<GenieRow {...props} />)
    expect(wrapper.find('GenieRow__Cell')).toHaveLength(props.data.length)
  })
})
